import type { FC } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import VerifyPage from "../pages/VerifyPage";

interface AppRoutesProps {}

const AppRoutes: FC<AppRoutesProps> = ({}) => {
  const token = localStorage.getItem("token");
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/verify" element={<VerifyPage/>} />
        {token ? (
          <Route path="/*" element={<PrivateRoutes />} />
        ) : (
          <Route path="/*" element={<PublicRoutes />} />
        )}

      </Routes>
    </BrowserRouter>
  );
};
export default AppRoutes;
